import { POLICY_ISSUANCE_MODES } from "../resources/enums";

export default class Intermediary {
    apikey: number;
    branchCode: string
    brokerId: number
    brokerName: string
    comprehensiveCommissionRate: number
    createdOn: string
    id: number
    insurerContactEmails: string
    insurerId: number
    insurerName: string
    intermediaryCode: string
    issuanceMode: POLICY_ISSUANCE_MODES
    midReady: boolean
    thirdPartyCommissionRate: number
    type: string
    updatedOn: string

    constructor(intermediary: IIntermediary) {
        this.apikey = intermediary.apikey;
        this.branchCode = intermediary.branchCode
        this.brokerId = intermediary.brokerId
        this.brokerName = intermediary.brokerName
        this.comprehensiveCommissionRate = intermediary.comprehensiveCommissionRate
        this.createdOn = intermediary.createdOn
        this.id = intermediary.id
        this.insurerContactEmails = intermediary.insurerContactEmails
        this.insurerId = intermediary.insurerId
        this.insurerName = intermediary.insurerName
        this.intermediaryCode = intermediary.intermediaryCode
        this.issuanceMode = intermediary.issuanceMode
        this.midReady = intermediary.midReady
        this.thirdPartyCommissionRate = intermediary.thirdPartyCommissionRate
        this.type = intermediary.type
        this.updatedOn = intermediary.updatedOn
    }
}

interface IIntermediary {
    apikey: number;
    branchCode: string
    brokerId: number
    brokerName: string
    comprehensiveCommissionRate: number
    createdOn: string
    id: number
    insurerContactEmails: string
    insurerId: number
    insurerName: string
    intermediaryCode: string
    issuanceMode: POLICY_ISSUANCE_MODES
    midReady: boolean
    thirdPartyCommissionRate: number
    type: string
    updatedOn: string
}